module.exports = __webpack_public_path__ + "img/404-error-dark.6d315ede.png";